import { callGet, callPost } from "../integrations/calls";


import { REQ } from "../../libs/constants";

export const getAllItemsSearch = async (token) => {
    return await callGet(`${REQ.SEARCH.ALL_ITEMS}`, token)
}

export const getSaleReg = async (data, token) => {
    return await callPost(REQ.ALL_REPORTS.GET_SALE_REG, data, token);
  };